import { supabase } from "@/integrations/supabase/client";
import {
  BULK_BATCH_SIZE,
  chunkArray,
  type BulkOperationProgress,
} from "@/lib/bulk-lead-operations";

export type BulkAssignCounts = {
  assigned: number;
  skipped: number;
};

/**
 * Uma RPC por lote de 200. Cada lote commita sozinho, então milhares de
 * leads não ficam presos numa única transação.
 */
export async function assignLeadsToMemberInBatches(
  workspaceId: string,
  leadIds: string[],
  memberId: string,
  onProgress?: (progress: BulkOperationProgress) => void,
): Promise<BulkAssignCounts> {
  const unique = [...new Set(leadIds.filter(Boolean))];
  const batches = chunkArray(unique, BULK_BATCH_SIZE);
  const total = unique.length;
  let assigned = 0;
  let skipped = 0;
  let completed = 0;

  onProgress?.({ completed: 0, total, label: "Atribuindo membro" });

  for (const chunk of batches) {
    const { data, error } = await supabase.rpc("bulk_assign_leads_to_member", {
      p_workspace_id: workspaceId,
      p_target_member_id: memberId,
      p_lead_ids: chunk,
    });
    if (error) throw error;

    const row = (data ?? {}) as { assigned?: number; skipped?: number };
    assigned += Number(row.assigned ?? 0);
    skipped += Number(row.skipped ?? 0);
    completed += chunk.length;
    onProgress?.({
      completed: Math.min(completed, total),
      total,
      label: "Atribuindo membro",
    });
  }

  return { assigned, skipped };
}
